module.exports = __webpack_public_path__ + "img/d.db7ebcf2.jpg";